import { Controller } from "@hotwired/stimulus"
import Toast from "bootstrap/js/dist/toast"

export default class extends Controller {
  connect() {
    this.toast = new Toast(this.element, { autohide: true, delay: 20000 })
    this.element.addEventListener("hidden.bs.toast", this.remove)
    this.toast.show()
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.toast", this.remove)
  }

  remove = () => {
    this.element.remove()
  }
}
